import React from 'react'
import BidderSuspension from '../../../utils/CommonFunctionality/BidderSuspension/Billing'
import DashboardHeader from '../DashboardHeader'
import Layout from '../Layout'

const Billing = (props) => {
    let is_abandon = global?.storeConfigration?.abandoned_schedule_hours?.value ? true : false
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    return (
        <Layout props={props}>
            <div className="GFdashWrapperContainer">
                <DashboardHeader />
                <BidderSuspension is_abandon={is_abandon} GFTheme={isVarifiedGfTheme} />
            </div>
        </Layout>
    )
}

export default Billing
